// import { $ } from "@olmokit/dom";
import baguetteBox from 'baguettebox.js';
import "./index.scss";

/**
 * Component: Lightbox
 */
export function Lightbox() {
  console.log("Lightbox mounted.");

  window.addEventListener('load', function() {
    baguetteBox.run('.gallery');
  });  
}
